/* eslint-disable @typescript-eslint/no-unsafe-argument */
import { Box, SystemProps } from "flicket-ui";
import { EventQuery } from "~graphql/sdk";
import { DesktopSubHeader } from "~components/common/common.BaseSubHeader";
import { ZonedDate } from "@flicket/utils";
import { useOrganization } from "~hooks";

type DesktopDetailProps = EventQuery["event"] & {
  showSeatsCTA: boolean;
  isSinglePage: boolean;
  setIsOpen: (isOpen: boolean) => void;
};

type EventTitleProps = Pick<
  DesktopDetailProps,
  "isSinglePage" | "title" | "startDate" | "endDate"
> & {
  hideBackLink?: boolean;
  backToLinkText?: string;
  backToLink?: string;
  venueName?: string;
  city?: string;
  tourId?: string;
  colour?: SystemProps["color"];
};

export const EventTitle = ({
  isSinglePage,
  backToLinkText = "Back to Events",
  backToLink = "/",
  hideBackLink = false,
  title,
  startDate,
  endDate,
  venueName,
  city,
  tourId,
  colour = "white",
}: EventTitleProps) => {
  const { organization, hasFeature } = useOrganization();

  const subTitle = (
    <>
      {ZonedDate.formatEventRange(startDate, endDate, {
        format: "basicLong",
        timeZone: organization.timezone,
        locale: organization.locale,
        showStartTime: !hasFeature("hideEventTime"),
      })}
      &nbsp;
      {!!venueName && (
        <Box as="span" d={{ _: "none", md: "inline-block" }}>
          - {`${venueName}, ${city ? city : ""}`}
        </Box>
      )}
    </>
  );
  return (
    <DesktopSubHeader
      title={title}
      subTitle={subTitle}
      isSinglePage={isSinglePage}
      backToLinkText={backToLinkText}
      backToLink={tourId ? `/tours/${tourId}` : backToLink}
      hideBackLink={hideBackLink}
      colour={colour}
    />
  );
};
